/* eslint-disable camelcase */
import api from '../../api'

const defaultState = () => ({
  admin: window.getItem('admin'),
  token: window.getItem('token')
  // admin: localStorage.getItem('admin'),
  // token: localStorage.getItem('token')
})

const logoutEvent = new Event('logout')

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    isAuthenticated: state => !!state.admin && !!state.token
  },
  mutations: {
    SET_ADMIN: (state, data) => {
      state.admin = data
    },
    SET_TOKEN: (state, data) => {
      state.token = data
    },
    RESET_STATE: state => {
      Object.assign(state, defaultState())
    }
  },
  actions: {
    async login (context, { email, password }) {
      const res = await api.login(email, password)
      if (res && res.data) {
        const admin = res.data.account
        const token = res.data.token
        context.commit('SET_ADMIN', admin)
        context.commit('SET_TOKEN', token)
        window.setItem('admin', admin)
        window.setItem('token', token)
        api.setToken(token)
        return res
      }
      throw new Error(res)
    },
    async logout () {
      window.dispatchEvent(logoutEvent)
    }
  }
}
